/* Crystal Paradise – Herkunfts-Weltkarte
   Section-scoped. Verfuegbare Kollektionen werden serverseitig in Liquid
   gerendert (JSON-Script in der Section) – kein /collections.json Fetch mehr. */
(function () {
  'use strict';

  function initSection(section) {
    var svg = section.querySelector('.cp-world-svg');
    if (!svg) return;

    var tooltip = section.querySelector('.cp-tooltip');
    var ttName  = section.querySelector('.cp-tooltip-name');
    var ttHint  = section.querySelector('.cp-tooltip-hint');
    var counter = section.querySelector('.cp-collection-count');
    var wrapper = section.querySelector('.cp-map-wrapper');

    var prefix     = section.getAttribute('data-cp-prefix')      || 'mineralien-aus-';
    var suffix     = section.getAttribute('data-cp-suffix')      || '-kaufen';
    var openHint   = section.getAttribute('data-cp-hint-open')   || '→ Kollektion öffnen';
    var emptyHint  = section.getAttribute('data-cp-hint-empty')  || 'Noch kein Sortiment vorhanden';
    var countLabel = section.getAttribute('data-cp-count-label') || 'Herkünfte im Shop';

    /* Umlaut-Schreibweisen auf eine gemeinsame Form bringen.

       Hintergrund: Die Karte benennt Laender deutsch transliteriert
       ('groenland', 'oesterreich', 'suedafrika'), Shopify erzeugt seine
       Handles dagegen ohne Umlautersatz ('gronland', 'osterreich'). Ein
       exakter Vergleich scheiterte deshalb bei jedem Umlaut-Land — bisher
       wurde das von Hand ausgeglichen, indem der Kollektions-Handle
       umbenannt wurde. Bei Groenland ist das durchgerutscht.

       Hier werden beide Seiten normalisiert, damit die Zuordnung
       unabhaengig von der Schreibweise trifft. */
    function cpNorm(h) {
      return String(h).toLowerCase()
        .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
        .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
    }

    // Serverseitig gerenderte Handle-Liste einlesen
    var available = new Set();
    var byNorm = {};
    var dataEl = section.querySelector('.cp-available-collections');
    if (dataEl) {
      try {
        JSON.parse(dataEl.textContent).forEach(function (h) {
          if (h) {
            available.add(h);
            var n = cpNorm(h);
            // Exakte Schreibweise gewinnt, falls zwei Handles gleich normalisieren
            if (!byNorm[n]) { byNorm[n] = h; }
          }
        });
      } catch (e) { /* ignore */ }
    }

    function moveTooltip(e) {
      if (!wrapper || !tooltip) return;
      var rect   = wrapper.getBoundingClientRect();
      var relY   = e.clientY - rect.top;
      var ttH    = tooltip.offsetHeight || 52;
      var margin = 12;
      tooltip.style.transform = (relY - ttH - margin < 0)
        ? 'translate(-50%, 18px)'
        : 'translate(-50%, -100%)';
      tooltip.style.left = (e.clientX - rect.left) + 'px';
      tooltip.style.top  = (e.clientY - rect.top - margin) + 'px';
    }

    var colCount = 0;
    var countries = svg.querySelectorAll('.cp-country');

    countries.forEach(function (el) {
      var name   = el.dataset.country || '';
      var slug   = el.dataset.slug    || '';
      var gesucht = prefix + slug + suffix;

      // Erst exakt, dann schreibweisen-tolerant (siehe cpNorm oben)
      var handle = available.has(gesucht) ? gesucht : byNorm[cpNorm(gesucht)];
      var hasCol = !!handle;

      if (hasCol) {
        colCount++;
        el.classList.add('has-collection');
        el.dataset.url = '/collections/' + handle;
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'button');
        el.setAttribute('aria-label', name + ' – Kollektion öffnen');
      }

      el.addEventListener('mouseenter', function (e) {
        if (ttName) ttName.textContent = name;
        if (ttHint) ttHint.textContent = hasCol ? openHint : emptyHint;
        moveTooltip(e);
        if (tooltip) tooltip.classList.add('visible');
      });
      el.addEventListener('mousemove', moveTooltip);
      el.addEventListener('mouseleave', function () {
        if (tooltip) tooltip.classList.remove('visible');
      });

      if (hasCol) {
        el.addEventListener('click', function () {
          el.classList.add('cp-active');
          window.location.href = el.dataset.url;
        });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.location.href = el.dataset.url;
          }
        });
      }
    });

    if (counter) {
      counter.textContent = colCount + ' ' + countLabel;
    }

    document.addEventListener('scroll', function () {
      if (tooltip) tooltip.classList.remove('visible');
    }, { passive: true });

    // Regions-Zoom
    var defaultViewBox = svg.getAttribute('data-default-viewbox') || '0 -60 2000 1040';
    var regions = {
      europa:      {x:900,  y:60,  w:450, h:280},
      afrika:      {x:860,  y:270, w:500, h:520},
      asien:       {x:1250, y:60,  w:800, h:560},
      nordamerika: {x:150,  y:60,  w:650, h:450},
      suedamerika: {x:380,  y:380, w:500, h:580},
      ozeanien:    {x:1580, y:440, w:580, h:460}
    };
    var activeReg = null;

    function zoomTo(region) {
      var r = regions[region];
      if (!r) return;
      svg.setAttribute('viewBox', r.x + ' ' + (r.y - 60) + ' ' + r.w + ' ' + r.h);
      activeReg = region;
    }
    function resetZoom() {
      svg.setAttribute('viewBox', defaultViewBox);
      activeReg = null;
    }

    section.querySelectorAll('.cp-region-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var reg = btn.dataset.region;
        section.querySelectorAll('.cp-region-btn').forEach(function (b) {
          b.classList.remove('cp-region-active');
        });
        if (reg === 'reset' || activeReg === reg) {
          resetZoom();
        } else {
          zoomTo(reg);
          btn.classList.add('cp-region-active');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.cp-worldmap-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
